import { Rectangle } from '@atlaskit/media-ui';
import { ZoomLevel } from '../../domain/zoomLevel';
export var clientRectangle = function clientRectangle(el) {
  var clientWidth = el.clientWidth,
    clientHeight = el.clientHeight;
  return new Rectangle(clientWidth, clientHeight);
};
export var naturalSizeRectangle = function naturalSizeRectangle(el) {
  // Firefox & Safari can't always read the "natural" dimensions correctly.
  // When these are undefined or zero, we replace them with the rendered values
  var naturalWidth = el.naturalWidth,
    naturalHeight = el.naturalHeight,
    width = el.width,
    height = el.height;
  return new Rectangle(naturalWidth || width, naturalHeight || height);
};
export function zoomLevelAfterResize(newCamera, oldCamera, oldZoomLevel) {
  var isImgScaledToFit = oldZoomLevel.value === oldCamera.scaleDownToFit;
  var zoomLevelToRefit = new ZoomLevel(newCamera.scaleDownToFit);
  return isImgScaledToFit ? zoomLevelToRefit : oldZoomLevel;
}